<template>
  <!-- eslint-disable -->
  <div>
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <TopNavClean />
      <div v-if="isLoading">
        <Loader />
      </div>
      <div v-else class="medical-order-page">
        <ModalCopiarOrden ref="modalcopiarorden" />

        <div class="contenido">
          <div class="page-header">
            <div class="header-content">
              <div class="title-section">
                <div class="page-icon" :style="{
                  backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                }">
                  <!-- SVG estilo ficha médica/paciente -->
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="16" rx="2" ry="2"></rect>
                    <path d="M8 9h8"></path>
                    <path d="M8 13h6"></path>
                    <circle cx="8" cy="16.5" r="0.5"></circle>
                    <path d="M16 16h2"></path>
                    <path d="M17 15v2"></path>
                    <circle cx="12" cy="9" r="1.5"></circle>
                  </svg>
                </div>
                <div>
                  <h1 class="page-title">Historial del Paciente</h1>
                  <p class="page-subtitle">Buscar pacientes y atenciones</p>
                </div>
              </div>
            </div>
            <div class="search-input-wrapper">
              <div class="search-icon">
                <!-- Ícono SVG -->
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
                    stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <input type="text" v-model="searchQuery" placeholder="Buscar por RUT" class="search-input" />
              <button @click="buscarPaciente" class="btn-primary"
                :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                Buscar paciente
              </button>
            </div>
          </div>

          <div class="ficha-wrapper">
            <!-- Columna de información del paciente (se convierte en acordeón en móvil) -->
            <div class="col-info">
              <div class="kpi-accordion" :class="{ 'expanded': kpiExpanded }">
                <div class="accordion-header" @click="toggleKpiAccordion">
                  <h3>Información del Paciente</h3>
                  <span class="accordion-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline v-if="kpiExpanded" points="18 15 12 9 6 15"></polyline>
                      <polyline v-else points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
                </div>

                <div class="accordion-content">
                  <!-- Información del paciente -->
                  <div class="historial-info" v-if="pacientes.length > 0">
                    <div class="paciente-info">
                      <h2 class="nombre">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icono" viewBox="0 0 24 24"
                          :style="{ fill: prestador.admin.assets.colors.primary }">
                          <path
                            d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
                        </svg>
                        {{ pacienteActual.nombre }} {{ pacienteActual.apellido1 }} {{ pacienteActual.apellido2 }}
                      </h2>

                      <p>
                        <svg xmlns="http://www.w3.org/2000/svg" class="icono" viewBox="0 0 24 24"
                          :style="{ fill: prestador.admin.assets.colors.primary }">
                          <path d="M4 4h16v2H4zM4 11h16v2H4zM4 18h16v2H4z" />
                        </svg>
                        {{ pacienteActual.rut }}
                      </p>

                      <p>
                        <svg xmlns="http://www.w3.org/2000/svg" class="icono" viewBox="0 0 24 24"
                          :style="{ fill: prestador.admin.assets.colors.primary }">
                          <path d="M4 4h16v16H4z" fill="none" />
                          <path d="M20 4H4v16h16V4zm-2 3l-6 5-6-5V6l6 5 6-5v1z" />
                        </svg>
                        {{ pacienteActual.email }}
                      </p>

                      <p>
                        <svg xmlns="http://www.w3.org/2000/svg" class="icono" viewBox="0 0 24 24"
                          :style="{ fill: prestador.admin.assets.colors.primary }">
                          <path
                            d="M6.6 10.8c1.5 3 3.9 5.4 6.9 6.9l2.3-2.3c.3-.3.8-.4 1.2-.3 1 .3 2.1.5 3.2.5.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C11.6 21 3 12.4 3 2c0-.6.4-1 1-1h3.1c.6 0 1 .4 1 1 0 1.1.2 2.2.5 3.2.1.4 0 .9-.3 1.2L6.6 10.8z" />
                        </svg>
                        {{ formatTelefono(pacienteActual.telefono) }}
                      </p>

                      <p>
                        <svg xmlns="http://www.w3.org/2000/svg" class="icono" viewBox="0 0 24 24"
                          :style="{ fill: prestador.admin.assets.colors.primary }">
                          <path
                            d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z" />
                        </svg>
                        {{ formatFecha(pacienteActual.fecha_nacimiento) }}
                      </p>
                    </div>

                    <!-- Resumen estadístico -->
                    <div class="resumen-section">
                      <div class="resumen-card kpi-card kpi-coral">
                        <div class="kpi-icon">
                        <!--
                        category: Document
                        tags: [medical, health, healthcare, medicine, hospital]
                        unicode: "f34e"
                        version: "1.88"
                        -->
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="36"
                          height="36"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ffffff"
                          stroke-width="1.75"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                          <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                          <path d="M11.993 16.75l2.747 -2.815a1.9 1.9 0 0 0 0 -2.632a1.775 1.775 0 0 0 -2.56 0l-.183 .188l-.183 -.189a1.775 1.775 0 0 0 -2.56 0a1.899 1.899 0 0 0 0 2.632l2.738 2.825z" />
                        </svg>

                        </div>
                        <h3>Total de atenciones</h3>
                        <p class="big-number">{{ resumen.total_atenciones }}</p>
                      </div>

                      <div class="resumen-card kpi-card kpi-yellow">
                        <div class="kpi-icon">
                          <!--
                          tags: [cancel, "no"]
                          version: "1.0"
                          category: Letters
                          unicode: "f4ae"
                          -->
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="36"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                            <path d="M10 8l4 8" />
                            <path d="M10 16l4 -8" />
                          </svg>
                        </div>
                        <h3>Agendas anuladas</h3>
                        <p class="big-number">{{ resumen.agendas_anuladas }}</p>
                      </div>

                      <div class="resumen-card kpi-card kpi-lime">
                        <div class="kpi-icon">
                          <!--
                          tags: [time, hour, watch, timepiece, twelve-hour, am/pm, noon, midday, daytime, clock-face]
                          category: System
                          version: "2.32"
                          unicode: "fc56"
                          -->
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="36"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M3 12a9 9 0 0 0 9 9m9 -9a9 9 0 1 0 -18 0" />
                            <path d="M12 7v5l.5 .5" />
                            <path d="M18 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2" />
                            <path d="M15 21v-6" />
                          </svg>
                        </div>
                        <h3>Día preferido</h3>
                        <p class="big-number">{{ translateDay(resumen.dia_preferido) }}</p>
                      </div>

                      <div class="resumen-card kpi-card kpi-blue">
                        <div class="kpi-icon">
                          <!--
                          tags: [notification, metric, ringing, mean, alertness, time, clockwork, signal, bell, chime]
                          category: System
                          version: "2.36"
                          unicode: "fc9e"
                          -->
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="36"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0" />
                            <path d="M7 4l-2.75 2" />
                            <path d="M17 4l2.75 2" />
                            <path d="M8 13h1l2 3l2 -6l2 3h1" />
                          </svg>
                        </div>
                        <h3>Horario preferida</h3>
                        <p class="big-number">{{ resumen.horario_preferido }}</p>
                      </div>

                      <div class="resumen-card kpi-card kpi-purple">
                        <div class="kpi-icon">
                          <!--
                          tags: [time, hour, watch, timepiece, twenty-four-hour, 24-hour, military, clock-face, round-clock, day-night]
                          category: System
                          version: "2.32"
                          unicode: "fc57"
                          -->
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="36"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M3 12a9 9 0 0 0 5.998 8.485m12.002 -8.485a9 9 0 1 0 -18 0" />
                            <path d="M12 7v5" />
                            <path d="M12 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2" />
                            <path d="M18 15v2a1 1 0 0 0 1 1h1" />
                            <path d="M21 15v6" />
                          </svg>
                        </div>
                        <h3>Periodo preferido</h3>
                        <p class="big-number">{{ resumen.periodo_preferido }}</p>
                      </div>
                    </div>

                    <!-- Prestadores y profesionales -->
                    <div class="list-section resumen-card kpi-card">
                      <div v-if="prestador.id === 1" class="resumen-list">
                        <h3>Prestadores</h3>
                        <ul>
                          <li v-for="(prestador, index) in resumen.prestadores" :key="'prestador-' + index">
                            {{ prestador }}
                          </li>
                        </ul>
                      </div>

                      <div class="resumen-list">
                        <h3>Profesionales</h3>
                        <ul>
                          <li v-for="(profesional, index) in resumen.profesionales" :key="'profesional-' + index">
                            {{ profesional }}
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="resumen-card chart-container-expanded"
                      v-if="resumen.atenciones_por_profesional && Object.keys(resumen.atenciones_por_profesional).length">
                      <h3>Atenciones por profesional</h3>
                      <div class="chart-wrapper">
                        <ProfesionalChart :data="chartProfesionalesData" :options="chartProfesionalesOptions" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-ficha">
              <!-- Historial de atenciones -->
              <div class="atenciones-section">
                <!-- Status Legend -->
                <div class="status-legend">
                  <h2><b> {{ searchingText }}</b></h2>
                  <div class="legend-items">
                    <div class="legend-item">
                      <div class="legend-color cancelled"></div>
                      <span>Anulado</span>
                    </div>
                    <div class="legend-item">
                      <div class="legend-color scheduled"></div>
                      <span>Citado</span>
                    </div>
                    <div class="legend-item">
                      <div class="legend-color confirmed"></div>
                      <span>Confirmado</span>
                    </div>
                    <div class="legend-item">
                      <div class="legend-color in-progress"></div>
                      <span>Atendido</span>
                    </div>
                    <div class="legend-item">
                      <div class="legend-color completed"></div>
                      <span>No Atendido</span>
                    </div>
                  </div>
                </div>

                <!-- Reemplaza la sección completa del atenciones-container con esto: -->

                <div class="atenciones-container">
                  <!-- SECCIÓN ATENCIONES FUTURAS -->
                  <div v-if="atencionesFuturas.length > 0" class="categoria-atenciones">
                    <div class="resumen-card kpi-card kpi-lime margin-card">
                      <!--
                      category: Development
                      tags: [calendar, schedule, date, add, new]
                      unicode: "f664"
                      version: "1.119"
                      -->
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        stroke-width="1.75"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M10 20h-6" />
                        <path d="M14 20h6" />
                        <path d="M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z" />
                        <path d="M10 8h4" />
                        <path d="M12 6v4" />
                      </svg>

                      <h3>Atenciones Futuras (Próximos 3+ días)</h3>
                      <span class="contador-categoria">{{ atencionesFuturas.length }}</span>
                    </div>
                    <div class="cards-grid">
                      <div class="atencion-card futura" v-for="(atencion, index) in atencionesFuturas"
                        :key="'futura-' + index" :class="{ 'cancelada': atencion.orden.estado === 4 }"
                        @click="showContextMenu($event, atencion)">
                        <div class="atencion-header">
                          <span class="fecha">{{ formatFecha(atencion.orden.fecha) }}</span>
                          <span class="estado" :class="getEstadoClass(atencion.orden.estado)">
                            {{ getEstadoText(atencion.orden.estado) }}
                          </span>
                        </div>

                        <div class="atencion-body">
                          <p>
                                                        <!--
                            tags: [hospital, doctor, medical, woman, emergency, medicine]
                            category: Health
                            version: "1.44"
                            unicode: "ef65"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M12 6c2.941 0 5.685 .847 8 2.31l-2 9.69h-12l-2 -9.691a14.93 14.93 0 0 1 8 -2.309z" />
                              <path d="M10 12h4" />
                              <path d="M12 10v4" />
                            </svg>

                            {{ atencion.orden && atencion.orden.profesional ? atencion.orden.profesional.nombre : 'Sin nombre' }}
                            {{ atencion.orden && atencion.orden.profesional ? atencion.orden.profesional.apellido : ''
                            }}
                          </p>

                          <p> <!--
                            tags: [car, hospital, health, report]
                            category: Health
                            version: "1.44"
                            unicode: "ef5a"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                              <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                              <path d="M9 14h.01" />
                              <path d="M9 17h.01" />
                              <path d="M12 16l1 1l3 -3" />
                            </svg>
                            {{ getServicios(atencion.orden.examenes) }}</p>
                          <p> 
                                                        <!--
                            category: System
                            tags: [plan, timetable, schedule, meeting, busy, month, year, date, statistics, calender]
                            version: "1.39"
                            unicode: "ee20"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4" />
                              <path d="M18 14v4h4" />
                              <path d="M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                              <path d="M15 3v4" />
                              <path d="M7 3v4" />
                              <path d="M3 11h16" />
                            </svg>

                            {{ formatHora(atencion.orden.desde) }} - {{
                            formatHora(atencion.orden.hasta) }}</p>
                          <p> 
                            <!--
                            category: Buildings
                            tags: [house, dashboard, living, building]
                            version: "1.1"
                            unicode: "eac0"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
                              <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
                              <path d="M10 12h4v4h-4z" />
                            </svg>

                          {{ atencion.orden.direccion }} {{ atencion.orden.comuna_id ? `(${getComunaName(atencion.orden.comuna_id)})` : '' }}</p>
                          <p>{{ getPrestador(atencion.orden.prestador_id).nombre }}</p>

                          <div v-if="atencion.orden.recetas && atencion.orden.recetas.length > 0" class="recetas">
                            <p><strong>Recetas asociadas:</strong> {{ atencion.orden.recetas.length }}</p>
                          </div>
                        </div>
                        <div class="download-container">
                          <button @click.stop="descargarPDF(atencion)" class="btn-download"
                            :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                            Descargar Atención en PDF
                          </button>
                          <div v-if="atencion.orden.recetas.length > 0">
                            <button @click.stop="fetchAndClickLink(atencion)" class="btn-download"
                              :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                              Descargar todas las recetas
                            </button>
                          </div>
                          <div v-else>
                            (sin recetas)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- SECCIÓN ATENCIONES PRESENTES -->
                  <div v-if="atencionesPresentes.length > 0" class="categoria-atenciones">
                    <div class="resumen-card kpi-card kpi-blue margin-card">
                      <!--
                      category: Development
                      tags: [calendar, schedule, date, error, warring]
                      unicode: "f662"
                      version: "1.119"
                      -->
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        stroke-width="1.75"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M10 20h-6" />
                        <path d="M14 20h6" />
                        <path d="M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z" />
                        <path d="M12 6v2" />
                        <path d="M12 11v.01" />
                      </svg>

                      <h3>Atenciones Presentes (Hoy + 2 días)</h3>
                      <span class="contador-categoria">{{ atencionesPresentes.length }}</span>
                    </div>
                    <div class="cards-grid">
                      <div class="atencion-card presente" v-for="(atencion, index) in atencionesPresentes"
                        :key="'presente-' + index" :class="{ 'cancelada': atencion.orden.estado === 4 }"
                        @click="showContextMenu($event, atencion)">
                        <div class="atencion-header">
                          <span class="fecha">{{ formatFecha(atencion.orden.fecha) }}</span>
                          <span class="estado" :class="getEstadoClass(atencion.orden.estado)">
                            {{ getEstadoText(atencion.orden.estado) }}
                          </span>
                        </div>

                        <div class="atencion-body">
                          <p>
                                                        <!--
                            tags: [hospital, doctor, medical, woman, emergency, medicine]
                            category: Health
                            version: "1.44"
                            unicode: "ef65"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M12 6c2.941 0 5.685 .847 8 2.31l-2 9.69h-12l-2 -9.691a14.93 14.93 0 0 1 8 -2.309z" />
                              <path d="M10 12h4" />
                              <path d="M12 10v4" />
                            </svg>

                            {{ atencion.orden && atencion.orden.profesional ? atencion.orden.profesional.nombre : 'Sin nombre' }}
                            {{ atencion.orden && atencion.orden.profesional ? atencion.orden.profesional.apellido : ''
                            }}
                          </p>

                          <p> <!--
                            tags: [car, hospital, health, report]
                            category: Health
                            version: "1.44"
                            unicode: "ef5a"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                              <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                              <path d="M9 14h.01" />
                              <path d="M9 17h.01" />
                              <path d="M12 16l1 1l3 -3" />
                            </svg>
                            {{ getServicios(atencion.orden.examenes) }}</p>
                          <p> 
                                                        <!--
                            category: System
                            tags: [plan, timetable, schedule, meeting, busy, month, year, date, statistics, calender]
                            version: "1.39"
                            unicode: "ee20"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4" />
                              <path d="M18 14v4h4" />
                              <path d="M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                              <path d="M15 3v4" />
                              <path d="M7 3v4" />
                              <path d="M3 11h16" />
                            </svg>

                            {{ formatHora(atencion.orden.desde) }} - {{
                            formatHora(atencion.orden.hasta) }}</p>
                          <p> 
                            <!--
                            category: Buildings
                            tags: [house, dashboard, living, building]
                            version: "1.1"
                            unicode: "eac0"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
                              <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
                              <path d="M10 12h4v4h-4z" />
                            </svg>

                          {{ atencion.orden.direccion }} {{ atencion.orden.comuna_id ? `(${getComunaName(atencion.orden.comuna_id)})` : '' }}</p>
                          <p>{{ getPrestador(atencion.orden.prestador_id).nombre }}</p>

                          <div v-if="atencion.orden.recetas && atencion.orden.recetas.length > 0" class="recetas">
                            <p><strong>Recetas asociadas:</strong> {{ atencion.orden.recetas.length }}</p>
                          </div>
                        </div>
                        <div class="download-container">
                          <button @click.stop="descargarPDF(atencion)" class="btn-download"
                            :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                            Descargar Atención en PDF
                          </button>
                          <div v-if="atencion.orden.recetas.length > 0">
                            <button @click.stop="fetchAndClickLink(atencion)" class="btn-download"
                              :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                              Descargar todas las recetas
                            </button>
                          </div>
                          <div v-else>
                            (sin recetas)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- SECCIÓN ATENCIONES PASADAS -->
                  <div v-if="atencionesPasadas.length > 0" class="categoria-atenciones">
                    <div class="resumen-card kpi-card kpi-purple margin-card">
                      <!--
                      category: Development
                      tags: [calendar, schedule, date, delete, remove]
                      unicode: "f663"
                      version: "1.119"
                      -->
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        stroke-width="1.75"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M10 20h-6" />
                        <path d="M14 20h6" />
                        <path d="M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z" />
                        <path d="M10 8h4" />
                      </svg>

                      <h3>Atenciones Pasadas</h3>
                      <span class="contador-categoria">{{ atencionesPasadas.length }}</span>
                    </div>
                    <div class="cards-grid">
                      <div class="atencion-card pasada" v-for="(atencion, index) in atencionesPasadas"
                        :key="'pasada-' + index" :class="{ 'cancelada': atencion.orden.estado === 4 }"
                        @click="showContextMenu($event, atencion)">
                        <div class="atencion-header">
                          <span class="fecha">{{ formatFecha(atencion.orden.fecha) }}</span>
                          <span class="estado" :class="getEstadoClass(atencion.orden.estado)">
                            {{ getEstadoText(atencion.orden.estado) }}
                          </span>
                        </div>

                        <div class="atencion-body">
                          <p>
                                                        <!--
                            tags: [hospital, doctor, medical, woman, emergency, medicine]
                            category: Health
                            version: "1.44"
                            unicode: "ef65"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M12 6c2.941 0 5.685 .847 8 2.31l-2 9.69h-12l-2 -9.691a14.93 14.93 0 0 1 8 -2.309z" />
                              <path d="M10 12h4" />
                              <path d="M12 10v4" />
                            </svg>

                            {{ atencion.orden && atencion.orden.profesional ? atencion.orden.profesional.nombre : 'Sin nombre' }}
                            {{ atencion.orden && atencion.orden.profesional ? atencion.orden.profesional.apellido : ''
                            }}
                          </p>

                          <p> <!--
                            tags: [car, hospital, health, report]
                            category: Health
                            version: "1.44"
                            unicode: "ef5a"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                              <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                              <path d="M9 14h.01" />
                              <path d="M9 17h.01" />
                              <path d="M12 16l1 1l3 -3" />
                            </svg>
                            {{ getServicios(atencion.orden.examenes) }}</p>
                          <p> 
                                                        <!--
                            category: System
                            tags: [plan, timetable, schedule, meeting, busy, month, year, date, statistics, calender]
                            version: "1.39"
                            unicode: "ee20"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4" />
                              <path d="M18 14v4h4" />
                              <path d="M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                              <path d="M15 3v4" />
                              <path d="M7 3v4" />
                              <path d="M3 11h16" />
                            </svg>

                            {{ formatHora(atencion.orden.desde) }} - {{
                            formatHora(atencion.orden.hasta) }}</p>
                          <p> 
                            <!--
                            category: Buildings
                            tags: [house, dashboard, living, building]
                            version: "1.1"
                            unicode: "eac0"
                            -->
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#2196f3"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
                              <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
                              <path d="M10 12h4v4h-4z" />
                            </svg>

                          {{ atencion.orden.direccion }} {{ atencion.orden.comuna_id ? `(${getComunaName(atencion.orden.comuna_id)})` : '' }}</p>
                          <p>{{ getPrestador(atencion.orden.prestador_id).nombre }}</p>

                          <div v-if="atencion.orden.recetas && atencion.orden.recetas.length > 0" class="recetas">
                            <p><strong>Recetas asociadas:</strong> {{ atencion.orden.recetas.length }}</p>
                          </div>
                        </div>
                        <div class="download-container">
                          <button @click.stop="descargarPDF(atencion)" class="btn-download"
                            :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                            Descargar Atención en PDF
                          </button>
                          <div v-if="atencion.orden.recetas.length > 0">
                            <button @click.stop="fetchAndClickLink(atencion)" class="btn-download"
                              :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                              Descargar todas las recetas
                            </button>
                          </div>
                          <div v-else>
                            (sin recetas)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- MENSAJE CUANDO NO HAY ATENCIONES -->
                  <div v-if="pacientes.length === 0 && !isLoading" class="no-atenciones">
                    <p>No se encontraron atenciones para este paciente.</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Menú contextual que se muestra al hacer clic en una atención -->
    <div v-if="popup" class="context-menu"
      :style="{ top: contextMenuPosition.y + 'px', left: contextMenuPosition.x + 'px' }" @mouseover="popup = true"
      @mouseleave="popup = false">
      <div class="context-menu-item" @click="copyToClipboard()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        </svg>
        Copiar pacientes
      </div>

      <div class="context-menu-item" @click="copiar_orden()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        </svg>
        Copiar orden
      </div>

      <div class="context-menu-item" @click="goto_receta()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14,2 14,8 20,8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
        </svg>
        Detalles de la orden
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import SideNav from './SideNav.vue';
import TopNavClean from './TopNavClean.vue';
import Loader from '@/components/Loader.vue';
import ProfesionalChart from './utils/ProfesionalChart.vue';
import ModalCopiarOrden from '@/components/utils/ModalCopiarOrden.vue';

import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
  name: 'HistorialPaciente',
  components: {
    SideNav,
    TopNavClean,
    Loader,
    ProfesionalChart,
    ModalCopiarOrden,
  },
  data() {
    return {
      pacientes: [],
      resumen: {
        agendas_anuladas: 0,
        dia_preferido: '',
        horario_preferido: '',
        prestadores: [],
        profesionales: [],
        total_atenciones: 0
      },
      searchingText: 'Iniciar búsqueda para mostrar información paciente',
      searchQuery: '',
      filteredAtenciones: [],
      isLoading: false,
      rut: '',
      popup: false,
      contextMenuPosition: { x: 0, y: 0 },
      ordenSeleccionada: null,
      ordenes: [],
      kpiExpanded: false,

      atencionesPasadas: [],
      atencionesPresentes: [],
      atencionesFuturas: [],
      fechaActual: new Date(),
    };
  },
  computed: {
    ...mapGetters(['admin_datos', 'isLoggedIn', 'sideMenu', 'prestador', 'comunas']),

    pacienteActual() {
      const cliente = this.pacientes?.[0]?.cliente ?? {};
      return {
        nombre: cliente.nombre ?? 'Sin nombre',
        apellido1: cliente.apellido1 ?? 'Sin apellido',
        apellido2: cliente.apellido2 ?? '',
        rut: cliente.rut ?? 'Sin RUT',
        email: cliente.email ?? '',
        telefono: cliente.telefono ?? '',
        fecha_nacimiento: cliente.fecha_nacimiento ?? ''
      };
    },
    chartProfesionalesData() {
      return {
        labels: Object.keys(this.resumen.atenciones_por_profesional || {}),
        datasets: [{
          label: 'Atenciones',
          data: Object.values(this.resumen.atenciones_por_profesional || {}),
          backgroundColor: 'rgba(75, 192, 192, 0.6)'
        }]
      };
    },
    chartProfesionalesOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        }
      };
    }
  },
  methods: {
    emptyCliente() {
      return {
        nombre: 'Sin nombre',
        apellido1: 'Sin apellido',
        apellido2: '',
        rut: 'Sin RUT',
        email: '',
        telefono: '',
        fecha_nacimiento: ''
      };
    },

    toggleKpiAccordion() {
      this.kpiExpanded = !this.kpiExpanded;
    },

    buscarPaciente() {
      if (!this.searchQuery?.trim()) return;
      this.rut = this.searchQuery.trim();
      this.get_historial_paciente();
    },

    clasificarAtenciones() {
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      const dosDiasDespues = new Date(hoy);
      dosDiasDespues.setDate(dosDiasDespues.getDate() + 2);
      dosDiasDespues.setHours(23, 59, 59, 999);

      const tresDiasDespues = new Date(hoy);
      tresDiasDespues.setDate(tresDiasDespues.getDate() + 3);
      tresDiasDespues.setHours(0, 0, 0, 0);

      this.atencionesPasadas = [];
      this.atencionesPresentes = [];
      this.atencionesFuturas = [];

      this.pacientes.forEach(atencion => {
        if (!atencion.orden || !atencion.orden.fecha) return;

        const fechaAtencion = new Date(atencion.orden.fecha);

        // Pasadas: antes de hoy
        if (fechaAtencion < hoy) {
          this.atencionesPasadas.push(atencion);
        }
        // Presentes: hoy y hasta 2 días después
        else if (fechaAtencion >= hoy && fechaAtencion <= dosDiasDespues) {
          this.atencionesPresentes.push(atencion);
        }
        // Futuras: 3 días desde hoy en adelante
        else if (fechaAtencion >= tresDiasDespues) {
          this.atencionesFuturas.push(atencion);
        }
      });

      this.atencionesPasadas.sort((a, b) => new Date(b.orden.fecha) - new Date(a.orden.fecha));
      this.atencionesPresentes.sort((a, b) => new Date(a.orden.fecha) - new Date(b.orden.fecha));
      this.atencionesFuturas.sort((a, b) => new Date(a.orden.fecha) - new Date(b.orden.fecha));
    },

    async get_historial_paciente() {
      this.isLoading = true;
      try {
        const { data } = await axios.post(
          `${window.hostname}/api/admin/get_historial_paciente`,
          { string_: this.rut }
        );

        if (data?.status?.code === 1000) {
          // Normalización estricta de datos
          this.pacientes = (data.clientes || []).map(p => {
            const cliente = p.cliente || {};
            return {
              ...p,
              cliente: {
                nombre: cliente.nombre || 'Sin nombre',
                apellido1: cliente.apellido1 || 'Sin apellido',
                apellido2: cliente.apellido2 || '',
                rut: cliente.rut || 'Sin RUT',
                email: cliente.email || '',
                telefono: cliente.telefono || '',
                fecha_nacimiento: cliente.fecha_nacimiento || '',
                ...cliente
              },
              orden: p.orden || {}
            };
          });

          this.clasificarAtenciones();

          this.resumen = data.resumen || this.$data.resumen;
          this.searchingText = 'Atenciones realizadas';

          if (window.innerWidth < 768) {
            this.kpiExpanded = true;
          }
        }
      } catch (error) {
        console.error('Error:', error);
        this.pacientes = [];
        this.atencionesPasadas = [];
        this.atencionesPresentes = [];
        this.atencionesFuturas = [];
        this.$toast.error('Error al cargar historial');
      } finally {
        this.isLoading = false;
      }
    },

    // Mostrar menú contextual al hacer clic en una atención
    showContextMenu(event, atencion) {
      event.preventDefault();
      event.stopPropagation();

      // Guardar la orden seleccionada
      this.ordenSeleccionada = atencion.orden;

      // Posicionar el menú contextual cerca del cursor
      this.contextMenuPosition = {
        x: event.clientX,
        y: event.clientY
      };

      // Mostrar el menú
      this.popup = true;

      // Agregar event listener para cerrar el menú al hacer clic en cualquier lugar
      document.addEventListener('click', this.closeContextMenu);
    },

    // Cerrar menú contextual
    closeContextMenu() {
      this.popup = false;
      document.removeEventListener('click', this.closeContextMenu);
    },

    filterHistorial() {
      if (!this.searchQuery?.trim()) {
        this.filteredAtenciones = [...this.pacientes];
        return;
      }

      const query = this.searchQuery.toLowerCase().trim();
      this.filteredAtenciones = this.pacientes.filter(p => {
        const c = p.cliente || this.emptyCliente();
        return [
          c.nombre.toLowerCase(),
          c.apellido1.toLowerCase(),
          c.rut
        ].some(f => f.includes(query));
      });
    },

    descargarPDF(atencion) {
      const doc = new jsPDF();

      const orden = atencion.orden;
      const cliente = atencion.cliente || {};

      const nombreCompleto = `${cliente.nombre || ''} ${cliente.apellido1 || ''} ${cliente.apellido2 || ''}`;
      const profesional = `${orden.profesional?.nombre || ''} ${orden.profesional?.apellido || ''}`;
      const fechaAtencion = this.formatFecha(orden.fecha);
      const horario = `${this.formatHora(orden.desde)} - ${this.formatHora(orden.hasta)}`;
      const comunaName = this.getComunaName(orden.comuna_id);
      const direccion = `${orden.direccion || 'No registrada'}${comunaName ? ` (${comunaName})` : ''}`;
      const estadoTexto = this.getEstadoText(orden.estado);
      const rut = cliente.rut;

      doc.setFontSize(16);
      doc.text('Informe de Atención Clínica', 14, 20);

      doc.setFontSize(12);
      doc.text(`Paciente: ${nombreCompleto}`, 14, 30);
      doc.text(`RUT: ${rut}`, 14, 37);
      doc.text(`Fecha de atención: ${fechaAtencion}`, 14, 44);
      doc.text(`Estado: ${estadoTexto}`, 14, 51);
      doc.text(`Profesional: ${profesional}`, 14, 58);
      doc.text(`Dirección: ${direccion}`, 14, 65);
      doc.text(`Horario: ${horario}`, 14, 72);

      if (orden.examenes?.length) {
        autoTable(doc, {
          head: [['Examen', 'Código', 'Precio']],
          body: orden.examenes.map(e => [e.nombre, e.codigo, `$${e.precio}`]),
          startY: 80,
        });
      }

      if (orden.recetas?.length) {
        doc.text(`Recetas asociadas: ${orden.recetas.length}`, 14, doc.lastAutoTable.finalY + 10);
      }

      doc.save(`atencion-${orden.id}.pdf`);
    },

    getPrestador(id) {
      const prestadores = [
        { nombre: 'Integramédica', prestador_id: 9, color: '#0079c8' },
        { nombre: 'Clínica Alemana', prestador_id: 5, color: '#01a49a' },
        { nombre: 'Laboratorio Blanco', prestador_id: 13, color: '#5e81bc' },
        { nombre: 'UC Christus', prestador_id: 14, color: '#872899' },
        { nombre: 'ClinicGo', prestador_id: 1, color: '#1486e7' },
        { nombre: 'Dávila', prestador_id: 15, color: '#F18A00' },
        { nombre: 'UC Christus En Casa', prestador_id: 16, color: '#872899' },
        { nombre: 'UC Christus Test', prestador_id: 21, color: '#872899' },
        { nombre: 'SportsMD', prestador_id: 18, color: '#2AB042' },
        { nombre: 'Bionet', prestador_id: 3, color: '#0884f4' },
        { nombre: 'Clínica Santa Maria', prestador_id: 22, color: '#536fa6' },
        { nombre: 'Mainque', prestador_id: 2, color: '#4a29d3' },
        { nombre: 'Mainque', prestador_id: 2, color: '#4a29d3' },
        { nombre: 'Clini', prestador_id: 4, color: '#5b398e' },
        { nombre: 'Clic Salud', prestador_id: 6, color: '#5b398e' },
        { nombre: 'Reley', prestador_id: 6, color: '#5b398e' },
        { nombre: 'Regonesi', prestador_id: 8, color: '#008cd5' },
        { nombre: 'CardioPro', prestador_id: 11, color: '#AF0009' },
        { nombre: 'CardioPro', prestador_id: 11, color: '#AF0009' },
        { nombre: 'Nomad', prestador_id: 20, color: '#506C6C' },
        { nombre: 'Testing', prestador_id: 23, color: '#506C6C' },
      ];

      const numericId = Number(id);
      const prestador = prestadores.find(p => p.prestador_id === numericId);
      return prestador ? prestador : { nombre: `Prestador ${id ?? '-'}`, color: '#94a3b8' };
    },
    
    getComunaName(id) {
      if (!id) return '';
      const comuna = this.comunas.find(c => c.id == id);
      return comuna ? comuna.Nombre : '';
    },

    async fetchAndClickLink(atencion) {
      const recetas = atencion.orden.recetas || [];

      for (const receta of recetas) {
        const recetaId = receta.id;

        try {
          const response = await axios.post(`${window.hostname}/api/admin/ver_receta_por_id`, {
            receta_id: recetaId
          });

          const link = response.data.link;
          if (link) {
            const a = document.createElement('a');
            a.href = link;
            a.download = '';
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        } catch (error) {
          console.error(`Error al descargar receta ${recetaId}:`, error);
        }
      }
    },

    // Métodos auxiliares seguros
    safeValue(value, fallback = '') {
      return value ?? fallback;
    },

    formatFecha(fechaStr) {
      try {
        return fechaStr ? new Date(fechaStr).toLocaleDateString('es-CL') : '';
      } catch {
        return '';
      }
    },

    formatHora(minutos) {
      const mins = Math.abs(parseInt(minutos) || 0);
      return `${Math.floor(mins / 60).toString().padStart(2, '0')}:${(mins % 60).toString().padStart(2, '0')}`;
    },

    formatTelefono(tel) {
      return typeof tel === 'string' ? tel.replace(/(\+56)+/g, '+56') : '';
    },

    getServicios(examenes) {
      if (!Array.isArray(examenes)) return 'Sin servicios';
      return examenes.map(e => this.safeValue(e?.nombre, 'Servicio sin nombre'))
        .filter(n => n)
        .join(', ') || 'Sin servicios';
    },

    getEstadoText(estado) {
      const estados = {
        0: 'Anulado', 1: 'Citado', 2: 'Confirmado',
        3: 'Atendido', 4: 'No Atendido'
      };
      return estados[this.safeValue(estado)] || 'Desconocido';
    },

    getEstadoClass(estado) {
      const clases = {
        0: 'cancelada', 1: 'pendiente', 2: 'confirmada',
        3: 'en-proceso', 4: 'completada'
      };
      return clases[this.safeValue(estado)] || '';
    },

    translateDay(day) {
      const days = {
        'Monday': 'Lunes', 'Tuesday': 'Martes', 'Wednesday': 'Miércoles',
        'Thursday': 'Jueves', 'Friday': 'Viernes', 'Saturday': 'Sábado',
        'Sunday': 'Domingo'
      };
      return days[this.safeValue(day)] || day;
    },

    copyToClipboard() {
      if (!this.ordenSeleccionada) return;

      let data = this.ordenSeleccionada;

      const rows = data.clientes.map(cliente => {
        return [
          data.id,
          new Date(data.fecha).toLocaleDateString('es-CL'),
          `${cliente.nombre} ${cliente.apellido1} ${cliente.apellido2}`.trim(),
          new Date(cliente.fecha_nacimiento).toLocaleDateString('es-CL'),
          cliente.rut,
          cliente.email,
          cliente.telefono,
          data.examenes.map(examen => examen.nombre).join(', '),
          data.direccion + ' (' + (data.departamento == 1 ? 'Departamento ' + data.n_depto : 'Casa') + ')',
          '', // Comuna (necesitarías mapear data.comuna_id)
          '', // Previsión (necesitarías mapear cliente.id_asegurador)
          '', // Región
          '', // Copago
          '', // Prestador
          `${this.formatHora(data.desde)} - ${this.formatHora(data.hasta)}`,
          data.profesional ? `${data.profesional.nombre} ${data.profesional.apellido}` : ''
        ].join('\t');
      }).join('\n');

      const el = document.createElement('textarea');
      el.value = rows;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.$notify({
        group: 'foo',
        title: '¡Éxito!',
        text: '¡Se copiaron los datos!',
        type: 'success'
      });

      this.closeContextMenu();
    },

    copiar_orden() {
      if (!this.ordenSeleccionada) return;

      this.$refs.modalcopiarorden.show(this.ordenSeleccionada);
      this.closeContextMenu();
    },

    goto_receta() {
      if (!this.ordenSeleccionada) return;

      this.$router.push({ path: '/VerReceta/' + this.ordenSeleccionada.id });
      this.closeContextMenu();
    },
  },

  beforeUnmount() {
    // Limpiar event listener al destruir el componente
    document.removeEventListener('click', this.closeContextMenu);
  }
};
</script>

<style scoped>
.ficha-wrapper {
  display: flex;
  gap: 1rem;
}

.col-info {
  flex: 1;
}

.col-ficha {
  flex: 3;
}

/* Estilos para el acordeón de KPI */
.kpi-accordion {
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  margin-bottom: 2rem;
  overflow: hidden;
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  cursor: pointer;
  background-color: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s ease;
}

.accordion-header:hover {
  background-color: #f1f5f9;
}

.accordion-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.accordion-icon {
  transition: transform 0.3s ease;
}

.kpi-accordion.expanded .accordion-icon {
  transform: rotate(180deg);
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.kpi-accordion.expanded .accordion-content {
  max-height: 2000px;
  /* Valor suficiente para mostrar todo el contenido */
}

/* Status Legend */
.status-legend {
  background-color: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: .5rem;
  margin-bottom: 0.5rem;
}

.legend-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 1rem 0;
}

.legend-items {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #64748b;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
}

.legend-color.cancelled {
  background: #ef4444;
}

.legend-color.scheduled {
  background: #f59e0b;
}

.legend-color.confirmed {
  background: #3b82f6;
}

.legend-color.in-progress {
  background: #8b5cf6;
}

.legend-color.completed {
  background: #10b981;
}

.medical-order-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  padding: 2rem;
  width: 100%;
  min-height: 100vh;
}

.column-left {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  z-index: 1000;
}

.column-right {
  background-color: var(--background-primary);
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.page-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.contenido {
  margin-top: 20px;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  gap: 0.75rem;
  background-color: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.5rem 1rem 0.5rem 2.75rem;
  margin-top: .5rem;
}

.search-input-wrapper.input {
  border: none;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.search-input-wrapper:focus-within {
  border-color: #0ea5e9;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

.search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.search-input {
  flex: 1;
  font-size: 0.875rem;
  color: #1f2937;
  padding: 0.625rem 1rem;
  border: none;
  background-color: transparent;
  outline: none;
}

.search-input::placeholder {
  color: #9ca3af;
}

.btn-primary {
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

input[type="text"] {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  font-size: 16px;
}

.historial-info {
  background: white;
  border-radius: 16px;
  padding: 0.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  display: grid;
}

.paciente-info {
  font-size: 16px;
}

.paciente-info .icono {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 8px;
}

.paciente-info h2,
.paciente-info p {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.resumen-section {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

/* .resumen-card {
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: .5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  margin-top: .5rem;
  color: white;
  text-shadow: 1px 1px 2px black;
}

.resumen-card h3 {
  margin-top: 0;
  font-size: 16px;
  color: white;
  text-shadow: 1px 1px 2px black;
} */

.resumen-list {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.list-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 2rem;
  gap: 20px;
}

.list-section>div {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.list-section ul {
  list-style: none;
  padding: 0;
}

.list-section li {
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}

.atenciones-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.categoria-atenciones {
  margin-bottom: 2rem;
  margin: 2rem 0;
}

.categoria-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  color: white;
  font-weight: 600;
}

.categoria-header.futura {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.categoria-header.presente {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}

.categoria-header.pasada {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
}

.contador-categoria {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1rem;
}

/* Estilos específicos para las cards según categoría */
.atencion-card.futura {
  border-left: 4px solid #10b981;
}

.atencion-card.presente {
  border-left: 4px solid #3b82f6;
}

.atencion-card.pasada {
  border-left: 4px solid #6b7280;
}

.no-atenciones {
  text-align: center;
  padding: 2rem;
  color: #64748b;
  font-style: italic;
}

.atencion-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.atencion-card.cancelada {
  opacity: 0.7;
  background-color: #fff9f9;
}

.atencion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f0f0f0;
  border-bottom: 1px solid #ddd;
}

.fecha {
  font-weight: bold;
}

.estado {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}

.estado.pendiente {
  background: #f59e0b;
  color: #f8ecd7;
}

.estado.confirmada {
  background: #3b82f6;
  color: #cfdef7;
}

.estado.en-proceso {
  background: #8b5cf6;
  color: #cec1ec;
}

.estado.completada {
  background: #10b981;
  color: #d1ece3;
}

.estado.cancelada {
  background: #ef4444;
  color: #f9dbdb;
}

.atencion-body {
  padding: 15px;
}

.atencion-body p {
  margin: 5px 0;
  display: flex;
  align-items: center;
  gap: 5px;
}

.download-container {
  display: block;
  margin: 0.5rem;
  padding: 0.5rem;
}

.btn-download {
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  margin: 0.5rem;
  font-weight: 600;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.recetas {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #ddd;
}

/* Context Menu */
.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  overflow: hidden;
  min-width: 220px;
}

.context-menu-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.875rem;
  font-weight: 500;
}

.context-menu-item:last-child {
  border-bottom: none;
}

.context-menu-item:hover {
  background: #f8fafc;
}

.context-menu-item.danger {
  color: #ef4444;
}

.context-menu-item.danger:hover {
  background: #fef2f2;
}

h1,
h2,
h3 {
  color: #2c3e50;
}

h2 {
  margin-top: 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}


/* Tarjetas base */
.resumen-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 2rem;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -2px rgb(0 0 0 / 0.05);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.resumen-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 10px 10px -5px rgb(0 0 0 / 0.04);
}

/* Iconos de KPI */
.kpi-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 1rem;
    opacity: 0.9;
}

.kpi-icon svg {
    width: 100%;
    height: 100%;
    color: #ffffff;
}

.icon-white {
    color: white
}

/* Títulos de KPI */
.kpi-card h3 {
    color: #ffffff;
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    line-height: 1.4;
    opacity: 0.95;
}

/* Números grandes */
.big-number {
    color: #ffffff;
    font-size: 2.25rem;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 0.25rem;
}

/* Subtítulos y descripciones */
.kpi-subtitle {
    color: #ffffff;
    font-size: 0.75rem;
    font-weight: 500;
    opacity: 0.8;
    margin-bottom: 0.25rem;
}

.kpi-description {
    color: #ffffff;
    font-size: 0.75rem;
    opacity: 0.7;
    line-height: 1.3;
}

.kpi-coral {
    background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
}

.kpi-yellow {
    background: linear-gradient(135deg, #ffd93d, #ffe066);
}

.kpi-lime {
    background: linear-gradient(135deg, #6bcf7f, #8dd99c);
}

.kpi-blue {
    background: linear-gradient(135deg, #4dabf7, #74c0fc);
}

.kpi-purple {
    background: linear-gradient(135deg, #9775fa, #b197fc);
}

.margin-card {
  margin-bottom: 2rem;
}

/* Media Queries para Responsividad */
@media (max-width: 1024px) {
  .ficha-wrapper {
    flex-direction: column;
    gap: 1.5rem;
  }

  .col-info,
  .col-ficha {
    flex: 1;
    width: 100%;
  }

  .kpi-accordion {
    margin-bottom: 1rem;
  }
}

@media (max-width: 1200px) {
  .column-left {
    display: none;
  }

  .column-right {
    padding-left: 0;
  }
}

@media (max-width: 768px) {

  .medical-order-page {
    padding: 1rem;
  }

  .page-header {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .page-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .search-input-wrapper {
    flex-direction: column;
    align-items: stretch;
    padding: 1rem;
    gap: 0.5rem;
  }

  .btn-primary {
    width: 100%;
    text-align: center;
  }

  .resumen-section,
  .list-section,
  .atenciones-container {
    grid-template-columns: 1fr;
  }

  .historial-info,
  .resumen-card,
  .resumen-list {
    padding: 1.5rem;
    margin-top: 1rem;
  }

  input[type="text"],
  .search-input {
    width: 100%;
    font-size: 1rem;
    padding: 0.75rem 1rem;
  }

  .atencion-card {
    border-radius: 6px;
  }

  h2 {
    font-size: 1.25rem;
    margin-top: 1.5rem;
  }

  .big-number {
    font-size: 20px;
  }

  .list-section {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .resumen-section {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
  }

  .resumen-card {
    padding: 1.5rem;
  }

  .paciente-info h2 {
    font-size: 1.25rem;
  }

  .paciente-info p {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .resumen-section {
    grid-template-columns: 1fr;
  }

  .legend-items {
    flex-direction: column;
    gap: 0.5rem;
  }

  .atenciones-container {
    grid-template-columns: 1fr;
  }

  .download-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .btn-download {
    width: 100%;
    margin: 0;
  }
}

.chart-container-expanded {
  margin-top: 1.5rem;
  width: 100%;
}

.chart-wrapper {
  height: 450px;
  width: 100%;
  margin-top: 1rem;
}

</style>